import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { BrandState } from 'reducers/brand';

const propTypes = {
  brand: PropTypes.instanceOf(BrandState).isRequired,
};

const AffiliateTerms = ({ brand }) => (
  <div id="affiliate-terms" className="container">
    <div className="margin-top-20" dangerouslySetInnerHTML={{ __html: brand.affiliateTerms }} />
  </div>
);

AffiliateTerms.propTypes = propTypes;

const mapStateToProps = state => ({
  brand: state.brand,
});

export default connect(mapStateToProps)(AffiliateTerms);
